import { format, parseISO } from 'date-fns';
import { AccountStatus } from '@hungryroot/customer';
import { OrderStatus, type Customer } from '@hungryroot/rest';
import { type Order } from '../../../../api/v2/customers/[id]/orders/[order_id]/get/get-customer-order';

export function getAccountStatus(
  customer: Pick<Customer, 'plan' | 'is_on_hold' | 'on_hold_until_date'>,
  nextCustomizableOrder?:
    | Pick<Order, 'status' | 'days_left_to_customize'>
    | undefined
): {
  accountStatus: AccountStatus;
  nextDeliveryDate?: string;
  daysToCustomize?: number;
} {
  const isCancelled = customer.plan === null;
  if (isCancelled) {
    return { accountStatus: AccountStatus.Cancelled };
  }

  const isPaused = customer.is_on_hold;
  const isSkipped = nextCustomizableOrder?.status === OrderStatus.Skipped;

  if (isPaused) {
    return {
      accountStatus: AccountStatus.Paused,
      nextDeliveryDate:
        customer.on_hold_until_date !== null
          ? format(parseISO(customer.on_hold_until_date), 'MMMM d')
          : undefined,
      daysToCustomize: undefined,
    };
  } else if (isSkipped) {
    return {
      accountStatus: AccountStatus.Skipped,
      nextDeliveryDate: undefined,
      daysToCustomize:
        nextCustomizableOrder.days_left_to_customize || undefined,
    };
  }

  return {
    accountStatus: AccountStatus.Active,
    nextDeliveryDate: undefined,
    daysToCustomize: undefined,
  };
}
